import { handleResponse, validateStatus } from '@ori/fetching';
import { getCustomerInfo as apiGetCustomerInfo } from '@ori/global-api-client-react';
/**
 * Utility function for the client and the server to Customer Type ID and Visitor Segment for the current customer ID.
 * Allows aborting requests via custom AbortController.
 * Provides fallback for non-fatal errors.
 */
export const getCustomerInfo = async ({
  abortController,
  client,
  customerId
}) => {
  const response = await apiGetCustomerInfo(client, customerId, undefined, {
    signal: abortController?.signal,
    validateStatus
  });
  return handleResponse(response, {
    onError: () => ({
      customerTypeId: undefined,
      visitorSegment: undefined
    }),
    onSuccess: ({
      data: {
        customerType,
        visitorSegment
      }
    }) => ({
      customerTypeId: customerType?.customerTypeId,
      visitorSegment
    })
  });
};
//# sourceMappingURL=getCustomerInfo.js.map